"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hole = exports.Via = exports.ViaShape = exports.Pad = exports.PadShape = exports.Smd = exports.ElementEntity = exports.Board = exports.BoardLayer = void 0;
exports.parseBoardXml = parseBoardXml;
const xml_js_1 = require("xml-js");
const Label_1 = require("./Label");
const Rectangle_1 = require("./Rectangle");
const Wire_1 = require("./Wire");
const Polygon_1 = require("./Polygon");
const Area_1 = require("../../../Area");
const Point_1 = require("./Point");
const Rotation_1 = require("./Rotation");
const Common_1 = require("./Common");
function parseBoardXml(input) {
    const json = (0, xml_js_1.xml2json)(input, { compact: true });
    const root = JSON.parse(json);
    return new Board(root.eagle);
}
class BoardLayer {
    constructor(layer) {
        this.wires = [];
        this.rectangles = [];
        this.vias = [];
        this.polygons = [];
        this.pads = [];
        this.smds = [];
        this.holes = [];
        this.labels = [];
        this.name = layer._attributes.name;
        this.visible = 'yes' === layer._attributes.visible;
        this.color = parseInt(layer._attributes.color);
        this.number = parseInt(layer._attributes.number);
        this.fill = parseInt(layer._attributes.fill);
    }
}
exports.BoardLayer = BoardLayer;
class Board {
    constructor(brd) {
        this.metadata = Common_1.Metadata.createFromBoard(brd);
        this.grid = new Common_1.Grid(brd.drawing.grid);
        this.layers = {};
        const boundary = new Area_1.default();
        let packages = {};
        packages = collectPackages(brd);
        brd.drawing.layers.layer.forEach((l) => (this.layers[l._attributes.number] = new BoardLayer(l)));
        (0, Common_1.toArray)(brd.drawing.board.elements.element).forEach((e) => {
            const element = new ElementEntity(e);
            const eaglePackage = selectPackage(packages, e._attributes.library, e._attributes.package);
            let pad;
            (0, Common_1.toArray)(eaglePackage.pad).forEach((p) => {
                pad = new Pad(p, element);
                this.layers[pad.layer].pads.push(pad);
                boundary.extendWithDimensions(pad.point.x, pad.point.y, pad.diameter ?? pad.drillDiameter, pad.diameter ?? pad.drillDiameter);
            });
            const wires = collectWires((0, Common_1.toArray)(eaglePackage.wire), element);
            Object.keys(wires).forEach((key) => {
                wires[key].forEach((wire) => {
                    this.layers[key].wires.push(wire);
                    boundary.extendWithVertices(wire.vertices.map((v) => v.toXYPosition()));
                });
            });
            let smd;
            (0, Common_1.toArray)(eaglePackage.smd).forEach((s) => {
                smd = new Smd(s, element);
                this.layers[smd.layer].smds.push(smd);
                boundary.extendWithDimensions(smd.point.x, smd.point.y, smd.width, smd.height);
            });
            let polygon;
            (0, Common_1.toArray)(eaglePackage.polygon).forEach((p) => {
                polygon = new Polygon_1.Polygon(p, element);
                this.layers[polygon.layer].polygons.push(polygon);
                boundary.extendWithVertices(polygon.vertices.map((v) => v.toXYPosition()));
            });
            let rect;
            (0, Common_1.toArray)(eaglePackage.rectangle).forEach((r) => {
                rect = Rectangle_1.Rectangle.createFromEagle(r, element);
                this.layers[rect.layer].rectangles.push(rect);
                boundary.extendWithDimensions(rect.point.x, rect.point.y, rect.width, rect.height);
            });
            let label;
            (0, Common_1.toArray)(e.attribute).forEach((t) => {
                label = Label_1.Label.fromEagleAttribute(t, e);
                if (label.hidden) {
                    return;
                }
                this.layers[label.layer].labels.push(label);
                boundary.extendWithArea(label.getArea());
            });
            (0, Common_1.toArray)(eaglePackage.text).forEach((t) => {
                label = Label_1.Label.fromEagleText(t, element);
                this.layers[label.layer].labels.push(label);
                boundary.extendWithArea(label.getArea());
            });
        });
        let wire;
        (0, Common_1.toArray)(brd.drawing.board.plain.wire)?.forEach((w) => {
            wire = Wire_1.Wire.createFromEagle(w);
            this.layers[wire.layer].wires.push(wire);
            boundary.extendWithVertices(wire.vertices.map((v) => v.toXYPosition()));
        });
        let rectangle;
        (0, Common_1.toArray)(brd.drawing.board.plain.rectangle)?.forEach((r) => {
            rectangle = Rectangle_1.Rectangle.createFromEagle(r);
            this.layers[rectangle.layer].rectangles.push(rectangle);
            boundary.extendWithDimensions(rectangle.point.x, rectangle.point.y, rectangle.width, rectangle.height);
        });
        let label;
        (0, Common_1.toArray)(brd.drawing.board.plain.text)?.forEach((t) => {
            label = Label_1.Label.fromEagleText(t);
            this.layers[label.layer].labels.push(label);
            boundary.extendWithArea(label.getArea());
        });
        let hole;
        (0, Common_1.toArray)(brd.drawing.board.plain.hole)?.forEach((h) => {
            hole = new Hole(h);
            this.layers[hole.layer].holes.push(hole);
            boundary.extendWithDimensions(hole.point.x, hole.point.y, hole.diameter, hole.diameter);
        });
        (0, Common_1.toArray)(brd.drawing.board.signals.signal)?.forEach((s) => {
            const wires = collectWires((0, Common_1.toArray)(s.wire));
            Object.keys(wires).forEach((key) => {
                wires[key].forEach((wire) => {
                    this.layers[key].wires.push(wire);
                    boundary.extendWithVertices(wire.vertices.map((v) => v.toXYPosition()));
                });
            });
            let via;
            (0, Common_1.toArray)(s.via)?.forEach((v) => {
                via = new Via(v);
                this.layers[via.layer].vias.push(via);
                boundary.extendWithDimensions(via.point.x, via.point.y, via.diameter, via.diameter);
            });
            let polygon;
            (0, Common_1.toArray)(s.polygon).forEach((p) => {
                polygon = new Polygon_1.Polygon(p);
                this.layers[polygon.layer].polygons.push(polygon);
                boundary.extendWithVertices(polygon.vertices.map((v) => v.toXYPosition()));
            });
        });
        this.metadata.boundary = boundary;
    }
}
exports.Board = Board;
class ElementEntity {
    constructor(e) {
        let rot = e._attributes.rot;
        this.point = new Point_1.Point(e._attributes.x, e._attributes.y);
        this.name = e._attributes.name;
        if (rot?.startsWith('M')) {
            this.mirrored = true;
            rot = rot.substr(1);
        }
        this.rotation = (0, Rotation_1.parseRotationFromDegrees)(rot);
    }
}
exports.ElementEntity = ElementEntity;
class Smd {
    constructor(s, parent) {
        let rot;
        this.name = s._attributes.name;
        this.parentName = parent.name;
        this.layer = parseInt(s._attributes.layer);
        this.width = parseFloat(s._attributes.dx);
        this.height = parseFloat(s._attributes.dy);
        this.roundness = s._attributes.roundness ? parseFloat(s._attributes.roundness) : 0;
        this.point = new Point_1.Point(parseFloat(s._attributes.x), parseFloat(s._attributes.y));
        this.point = this.point.rotate(parent.rotation);
        if (parent.mirrored) {
            this.point.x = -this.point.x;
        }
        rot = (0, Rotation_1.parseRotationFromDegrees)(s._attributes.rot);
        rot = (0, Rotation_1.combineRotations)(rot, parent.rotation);
        if ([Rotation_1.Rotation.R90, Rotation_1.Rotation.R270].includes(rot)) {
            const tmp = this.width;
            this.width = this.height;
            this.height = tmp;
        }
        this.point.x -= this.width / 2;
        this.point.y -= this.height / 2;
        this.point.add(parent.point);
    }
}
exports.Smd = Smd;
var PadShape;
(function (PadShape) {
    PadShape[PadShape["octagon"] = 0] = "octagon";
    PadShape[PadShape["long"] = 1] = "long";
    PadShape[PadShape["offset"] = 2] = "offset";
    PadShape[PadShape["square"] = 3] = "square";
    PadShape[PadShape["round"] = 4] = "round";
})(PadShape || (exports.PadShape = PadShape = {}));
class Pad {
    constructor(p, parent) {
        this.drawDirection = parent.rotation;
        this.layer = 17;
        this.point = new Point_1.Point(p._attributes.x, p._attributes.y);
        this.drillDiameter = parseFloat(p._attributes.drill);
        this.name = p._attributes.name;
        this.parentName = parent.name;
        this.diameter = p._attributes.diameter ? parseFloat(p._attributes.diameter) : undefined;
        this.shape = (() => {
            switch (p._attributes.shape) {
                case 'octagon':
                    return PadShape.octagon;
                case 'long':
                    return PadShape.long;
                case 'offset':
                    return PadShape.offset;
                case 'square':
                    return PadShape.square;
                case 'round':
                default:
                    return PadShape.round;
            }
        })();
        this.drawDirection = (0, Rotation_1.parseRotationFromDegrees)(p._attributes.rot);
        this.drawDirection = (0, Rotation_1.combineRotations)(this.drawDirection, parent.rotation);
        this.point = this.point.rotate(parent.rotation);
        if (parent.mirrored) {
            this.point.x = -this.point.x;
        }
        this.point.add(parent.point);
    }
}
exports.Pad = Pad;
var ViaShape;
(function (ViaShape) {
    ViaShape[ViaShape["octagon"] = 0] = "octagon";
    ViaShape[ViaShape["square"] = 1] = "square";
    ViaShape[ViaShape["round"] = 2] = "round";
})(ViaShape || (exports.ViaShape = ViaShape = {}));
class Via {
    constructor(eagleVia) {
        this.point = new Point_1.Point(eagleVia._attributes.x, eagleVia._attributes.y);
        this.drillDiameter = parseFloat(eagleVia._attributes.drill);
        this.layer = 18;
        this.diameter = this.drillDiameter * 2;
        switch (eagleVia._attributes.shape) {
            case 'octagon':
                this.shape = ViaShape.octagon;
                break;
            case 'square':
                this.shape = ViaShape.square;
                break;
            case 'round':
            default:
                this.shape = ViaShape.round;
                break;
        }
    }
}
exports.Via = Via;
class Hole {
    constructor(h) {
        this.point = new Point_1.Point(h._attributes.x, h._attributes.y);
        this.diameter = parseFloat(h._attributes.drill);
        this.layer = 45;
    }
}
exports.Hole = Hole;
function collectWires(eagleWires, parent) {
    const result = {};
    let wire;
    let prevWire = undefined;
    if (!eagleWires) {
        return {};
    }
    for (let i = 0; i < eagleWires.length; i++) {
        wire = Wire_1.Wire.createFromEagle(eagleWires[i], parent);
        if (!prevWire) {
            prevWire = wire;
        }
        else if (!prevWire.combine(wire)) {
            if (!result[prevWire.layer]) {
                result[prevWire.layer] = [];
            }
            result[prevWire.layer].push(prevWire);
            prevWire = wire;
        }
    }
    if (prevWire) {
        if (!result[prevWire.layer]) {
            result[prevWire.layer] = [];
        }
        result[prevWire.layer].push(prevWire);
    }
    return result;
}
function collectPackages(brd) {
    const packages = {};
    (0, Common_1.toArray)(brd.drawing.board.libraries.library).forEach((l) => {
        (0, Common_1.toArray)(l.packages.package).forEach((p) => {
            packages[`${l._attributes.name}::${p._attributes.name}`] = p;
        });
    });
    return packages;
}
function selectPackage(packages, libraryName, packageName) {
    return packages[`${libraryName}::${packageName}`];
}
//# sourceMappingURL=Board.js.map